export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const LANDING = '/'
export const HOME = '/home'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/pw-forget'
export const ABOUT = '/about'
export const EDITPROFILE = '/edit-profile'
export const YOURPROFILE = '/your-profile'
export const SETTINGS = '/settings'
export const CHAT = '/chat'


// WEBPACK FOOTER //
// ./src/constants/routes.js